<mat-toolbar
  [ngClass]="[isSticked ? 'transparent' : '', variant, theme ? theme : '']"
>
  <mat-toolbar-row class="container">
    <a href="/?sh=true" class="logo" data-ga-value="navbar-link-logo">
      <img
        src="/shared/img/logo/desktop/fantaz_logo_{{
          (isSticked && theme === 'white') || theme === 'dark'
            ? 'white'
            : 'black'
        }}_1x.webp"
        srcset="/shared/img/logo/desktop/fantaz_logo_{{
          ((isSticked && theme === 'white') || theme === 'dark') ? 'white' : 'black'
        }}_1x.webp 1x,
        /shared/img/logo/desktop/fantaz_logo_{{
          ((isSticked && theme === 'white') || theme === 'dark') ? 'white' : 'black'
        }}_2x.webp 2x,
        /shared/img/logo/desktop/fantaz_logo_{{
          ((isSticked && theme === 'white') || theme === 'dark') ? 'white' : 'black'
        }}_3x.webp 3x,
        /shared/img/logo/desktop/fantaz_logo_{{
          ((isSticked && theme === 'white') || theme === 'dark') ? 'white' : 'black'
        }}_4x.webp 4x
        "
        alt="FantaZ Logo"
        height="42"
      />
    </a>
    <a href="/?sh=true" class="logo mobile" data-ga-value="navbar-link-logo">
      <img
        src="/shared/img/logo/mobile/fantaz_logo_1x.webp"
        srcset="
          /shared/img/logo/mobile/fantaz_logo_1x.webp 1x,
          /shared/img/logo/mobile/fantaz_logo_2x.webp 2x,
          /shared/img/logo/mobile/fantaz_logo_3x.webp 3x,
          /shared/img/logo/mobile/fantaz_logo_4x.webp 4x
        "
        alt="FantaZ Logo"
        height="40"
      />
    </a>
    <span class="menu-spacer"></span>
    <div class="navbar-menu">
      <a
        class="navbar-link"
        [href]="'/' + playPage"
        mat-button
        [class.active]="playActive"
        data-ga-value="navbar-link-tournaments"
        >Play</a
      >
      <a
        class="navbar-link"
        (click)="onPromote()"
        mat-button
        data-ga-value="navbar-link-promote"
        >Promote</a
      >
      <a
        class="navbar-link"
        href="/profit"
        mat-button
        [class.mat-primary]="router.isActive('profit', false)"
        data-ga-value="navbar-link-profit"
        >Profit</a
      >
    </div>
    <div class="spacer"></div>
    <div>
      <a
        mat-button
        *ngIf="(isLoggedIn$ | async) !== true"
        class="promote-code"
        data-ga-value="navbar-promote-code"
        (click)="onPromoCode()"
      >
        <mat-icon class="material-icons-outlined"> sell </mat-icon>
        <span class="text"> Promo <span>Code</span></span>
      </a>
    </div>
    <div *ngIf="(isLoggedIn$ | async) === false">
      <a
        mat-button
        class="navbar-link-login"
        (click)="onLogin()"
        data-ga-value="navbar-link-login"
        >Login</a
      >
      <a
        mat-flat-button
        class="join-now animation__glow"
        color="primary"
        (click)="onSignUp()"
        data-ga-value="navbar-link-join-now"
        >Join Now</a
      >
    </div>

    <!-- !fixme: the user navbar is only show when user is authenticated -->
    <fz-navbar-user
      [theme]="theme"
      [currentUser]="user$ | async"
      [wallet]="wallet$ | async"
      [isSticked]="isSticked"
      [enableSwitchTheme]="enableSwitchTheme"
      (login)="onLogin()"
      (signUp)="onSignUp()"
      (promote)="onPromote()"
      (themeChange)="onThemeChange($event)"
      (promoteCode)="onPromoCode()"
      (logout)="onLogout()"
    ></fz-navbar-user>
    <div class="theme-switcher">
      <fz-color-scheme-switcher
        *ngIf="enableSwitchTheme"
        (toggleChange)="onThemeChange($event)"
      ></fz-color-scheme-switcher>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
